import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import PictureComp from '@/components/picture/PictureComp.vue';
import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import BasicButton from '@/ui-components/BasicButton.vue';

import { CollectionType } from '@/enums/collection-type';
import { OnboardingStatus } from '@/enums/onboarding-status';

import { useRoute, useRouter } from 'vue-router/composables';
import { useConstantStore, useFilterStore, useRoutingStore, useUserStore } from '@/helpers/composables/useStores';

import { calculateUrl } from '@/helpers/state-helper';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import { Package } from '@/@types/graphql-types';


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalHero',
  emits: ['click'],
  setup(__props, { emit }) {



const route = useRoute();
const router = useRouter();
const { genresByShortName, subgenresList, providersByShortName, allProviders, preselectedProviders } =
	useConstantStore();
const { setFilterValue } = useFilterStore();
const { saveOnboardingStatus, saveSettings, isLoggedIn } = useUserStore();
const { fetchUrlMetadata } = useRoutingStore();

const DISCOVERY_INVITATION_EVENT_CATEGORY = 'discovery';

const backdropUrl = `https://www.justwatch.com/${ASSETS_DIR}/img/home/global-home-bg-comp.{format}`;

const providerList = computed(() => allProviders.value(false).slice(0, 13) as Package[]);

const providerListMobile = computed<Package[]>(() => providerList.value.slice(0, 4));

const providerUrls = computed(() =>
	Object.fromEntries(
		providerList.value.map(({ shortName }) => [
			shortName,
			calculateUrl(
				router,
				undefined,
				CollectionType.POPULAR,
				{ providers: [shortName] },
				providersByShortName.value,
				genresByShortName.value,
				subgenresList.value
			),
		])
	)
);

const collectionTypes = [CollectionType.POPULAR, CollectionType.NEW];
async function discoverClickHandler() {
	collectionTypes.forEach(collectionType => {
		setFilterValue({
			filterName: 'providers',
			filterValue: [],
			collectionType,
			updateRouteState: false,
		});
	});

	TrackingHelper.trackEvent(DISCOVERY_INVITATION_EVENT_CATEGORY, {
		action: 'invitation_clicked',
		property: 'top',
	});

	await saveSettings({ providers: preselectedProviders.value });

	saveOnboardingStatus(isLoggedIn.value ? OnboardingStatus.SIGNED_UP : OnboardingStatus.GLOBAL_CLICKED_CTA);

	await fetchUrlMetadata(route.path);

	emit('click');
}

function featuresClickHandler() {
	TrackingHelper.trackEvent('userinteraction', {
		action: 'show_features_clicked',
	});

	let element = document.getElementById('features');
	let headerOffset = 110;
	let elementPosition = element?.getBoundingClientRect().top || 0;
	let offsetPosition = elementPosition + window.scrollY - headerOffset;

	window.scrollTo({
		top: offsetPosition,
		behavior: 'smooth',
	});
}

function handleProviderClick(providerName: string) {
	TrackingHelper.trackEvent('userinteraction', {
		action: 'provider_clicked',
		property: providerName,
	});
}

function handleSeeAllClick() {
	TrackingHelper.trackEvent('userinteraction', {
		action: 'provider_select_all_clicked',
	});
}

return { __sfc: true,emit, route, router, genresByShortName, subgenresList, providersByShortName, allProviders, preselectedProviders, setFilterValue, saveOnboardingStatus, saveSettings, isLoggedIn, fetchUrlMetadata, DISCOVERY_INVITATION_EVENT_CATEGORY, backdropUrl, providerList, providerListMobile, providerUrls, collectionTypes, discoverClickHandler, featuresClickHandler, handleProviderClick, handleSeeAllClick, PictureComp, ProviderIcon, BasicButton }
}

})